import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  root: prop => {
    const isError = typeof prop === 'boolean' && prop;

    return {
      marginBottom: 12,
      backgroundColor: theme.colors.light.snow,
      borderRadius: 6,

      '& .MuiFilledInput-root': {
        color: isError && theme.colors.red,
        borderRadius: 6,
        border: isError
          ? `2px solid ${theme.colors.red}`
          : `2px solid ${theme.colors.light.ghostWhite}`,

        '&:before': {
          borderBottom: 0,
        },
        '&:after': {
          display: 'none',
        },

        '@media(max-width: 379px)': {
          fontSize: theme.fonts.sizes.font12PX,
        },
      },

      '& .MuiFilledInput-input[value=""]': {
        padding: '18px 12px',
      },

      '& .MuiFilledInput-root.Mui-focused': {
        borderColor: isError
          ? theme.colors.red
          : theme.colors.dark.midnightBlue,
      },

      '& .MuiFormLabel-root.Mui-focused': {
        color: theme.colors.dark.midnightBlue,
      },
    };
  },
}));

export const useStylesHelperText = makeStyles(theme => ({
  text: {
    margin: '-8px 0 20px 10px',
    color: theme.colors.red,
    fontSize: theme.fonts.sizes.font12PX,
  },
}));
